import styled from 'styled-components'
import { Link as Link_ } from 'gatsby-plugin-intl'

// eslint-disable-next-line import/prefer-default-export
export const Link = styled(Link_)`
  color: #444444;
  text-decoration: none;
  &:hover,
  &:active,
  &:visited {
    color: #444444;
  }
`
